import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

const ZOOM_STEP = 0.25;
const DEFAULT_ZOOM = 1;

@Component({
  selector: 'app-modal-detail',
  templateUrl: './modal-detail.component.html',
  styleUrls: ['./modal-detail.component.scss']
})
export class ModalDetailComponent implements OnInit {
  textButton: any;
  textTitle: any;
  txtContent: any;
  type: any;
  icon: any;
  elementId: any;
  url: any;
  load: boolean;
  errorPdf = false;

  public pdfZoom = DEFAULT_ZOOM;

  constructor(public dialogRef: MatDialogRef<ModalDetailComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    // console.log(this.data);
    this.type = this.data.type;
    this.url = this.data.url;
    this.textTitle = this.data.title;

    if(this.type == 'view_pdf'){
      this.load = true;
    }
  }

  ngOnInit() {
  }

  zoomPlus(){
    this.load = true;
    this.pdfZoom += ZOOM_STEP;
  }

  zoomRest(){
    if (this.pdfZoom > DEFAULT_ZOOM) {
      this.load = true;
      this.pdfZoom -= ZOOM_STEP;
    }
  }

  resetZoom() {
    this.pdfZoom = DEFAULT_ZOOM;
  }

  errorLoadPdf(ev){
    // console.log('(error)',ev);
    this.errorPdf = true;
  }

  loadPdf(ev){
    // console.log('(load)',ev);
  }

  pageRendered(e) {
    this.load = false;
  }

  onCloseConfirm() {
    this.dialogRef.close(true);
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

}
